export class PlanejamentoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getPlanejamento(filter, type) {
    return this.instance.get(`/v1/planejamentos/orcamentos/${type}`, {
      params: filter || null,
    });
  }

  getOrcamento(filter) {
    return this.instance.get(`/v1/planejamentos/orcamentos`, {
      params: filter || null,
    });
  }

  getGraficoVendasReceita(filter) {
    return this.instance.get(`/v1/planejamentos/orcamentos/grafico-receita`, {
      params: filter || null,
    });
  }

  getPlanejamentoRelatorio(filter) {
    return this.instance.get(`/v1/planejamentos/orcamentos/relatorio`, {
      params: filter || null,
    });
  }

  insertOrcamentos(data) {
    return this.instance.put(`/v1/planejamentos/orcamentos`, data);
  }

  getGraficoOrcamento(filters) {
    return this.instance.get('/v1/planejamentos/orcamentos/grafico', {
      params: filters || null,
    });
  }

  getPlajenamentoAtividadeTalhoes(filter) {
    return this.instance.get('/v1/planejamentos/atividade-talhoes', {
      params: filter || null,
    });
  }

  createUpdatePlanejamentoAtividadeTalhoes(data) {
    return this.instance.post(
      '/v1/planejamentos/atividade-talhoes/talhoes',
      data,
    );
  }

  createUpdateAtividadeCronogramaTalhao(id, data) {
    return this.instance.post(
      `/v1/planejamentos/atividade-talhoes/cronograma/atividades/${id}`,
      data,
    );
  }

  getTalhoesDatasMaquinasByAtividade(id, filter) {
    return this.instance.get(
      `/v1/planejamentos/atividade-talhoes/cronograma/atividades/${id}`,
      { params: filter || null },
    );
  }

  getComparativoExecucaoByAtividade(id, filter) {
    return this.instance.get(
      `/v1/planejamentos/atividade-talhoes/cronograma/atividades/${id}/comparativo`,
      { params: filter || null },
    );
  }

  trocarConcluidoPlanejamentoAtividadeTalhao(atividadeId, talhaoId, data) {
    return this.instance.patch(
      `/v1/planejamentos/atividade-talhoes/atividades/${atividadeId}/talhoes/${talhaoId}/concluido`,
      data,
    );
  }
}

export default PlanejamentoFactory;
